"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateAddress = exports.getFavouriteAddress = exports.getAddresses = exports.getAddressSpecificities = exports.getAddress = exports.deleteAddress = exports.createAddress = void 0;
var _types = require("./types");
/**
 * Module dependencies
 */

const payload = res => ({
  status: res.status,
  statusText: res.statusText,
  data: {
    ...res.data
  },
  error: {}
});
const errPayload = err => {
  if (!err.response) return {
    status: 'Error',
    statusText: err.message,
    data: {},
    error: {}
  };
  return {
    status: err.response.status,
    statusText: err.response.statusText,
    data: {},
    error: {
      ...err.response.data
    }
  };
};

/**
 * GET ADDRESS
 * @returns {function(*): Promise}
 */
const getAddress = id => (state, dispatch) => state.client.getAddress(id).then(res => {
  dispatch({
    type: _types.GET_ADDRESS,
    payload: payload(res)
  });
  return res;
}).catch(err => {
  dispatch({
    type: _types.GET_ADDRESS_FAILED,
    payload: errPayload(err)
  });
  return Promise.reject(err);
});

/**
 * GET ADDRESSES
 * @returns {function(*): Promise}
 */
exports.getAddress = getAddress;
const getAddresses = () => (state, dispatch) => state.client.getAddresses().then(res => {
  dispatch({
    type: _types.GET_ADDRESSES,
    payload: payload(res)
  });
  return res;
}).catch(err => {
  dispatch({
    type: _types.GET_ADDRESSES_FAILED,
    payload: errPayload(err)
  });
  return Promise.reject(err);
});

/**
 * CREATE ADDRESS
 * @returns {function(*): Promise}
 */
exports.getAddresses = getAddresses;
const createAddress = data => (state, dispatch) => state.client.createAddress(data).then(res => {
  dispatch({
    type: _types.CREATE_ADDRESS,
    payload: payload(res)
  });
  return res;
}).catch(err => {
  dispatch({
    type: _types.CREATE_ADDRESS_FAILED,
    payload: errPayload(err)
  });
  return Promise.reject(err);
});

/**
 * UPDATE ADDRESS
 * @returns {function(*): Promise}
 */
exports.createAddress = createAddress;
const updateAddress = data => (state, dispatch) => state.client.updateAddress(data).then(res => {
  dispatch({
    type: _types.UPDATE_ADDRESS,
    payload: payload(res)
  });
  return res;
}).catch(err => {
  dispatch({
    type: _types.UPDATE_ADDRESS_FAILED,
    payload: errPayload(err)
  });
  return Promise.reject(err);
});

/**
 * DELETE ADDRESS
 * @returns {function(*): Promise}
 */
exports.updateAddress = updateAddress;
const deleteAddress = id => (state, dispatch) => state.client.deleteAddress(id).then(res => {
  dispatch({
    type: _types.DELETE_ADDRESS,
    payload: payload(res)
  });
  return res;
}).catch(err => {
  dispatch({
    type: _types.DELETE_ADDRESS_FAILED,
    payload: errPayload(err)
  });
  return Promise.reject(err);
});

/**
 * GET FAVOURITE ADDRESSSES
 * @returns {function(*): Promise}
 */
exports.deleteAddress = deleteAddress;
const getFavouriteAddress = () => (state, dispatch) => state.client.getFavouriteAddress().then(res => {
  dispatch({
    type: _types.GET_FAVOURITE_ADDRESS,
    payload: payload(res)
  });
  return res;
}).catch(err => {
  dispatch({
    type: _types.GET_FAVOURITE_ADDRESS_FAILED,
    payload: errPayload(err)
  });
  return Promise.reject(err);
});

/**
 * GET ADDRESS SPECIFICITIES
 * @returns {function(*): Promise}
 */
exports.getFavouriteAddress = getFavouriteAddress;
const getAddressSpecificities = () => (state, dispatch) => state.client.getAddressSpecificities().then(res => {
  dispatch({
    type: _types.GET_ADDRESS_SPECIFICITIES,
    payload: res.data?.configurationDetails?.addressFieldSpecificities
  });
  return res;
}).catch(err => {
  dispatch({
    type: _types.GET_ADDRESS_SPECIFICITIES_FAILED,
    payload: errPayload(err)
  });
  return Promise.reject(err);
});
exports.getAddressSpecificities = getAddressSpecificities;